// extracted by mini-css-extract-plugin
module.exports = {"deletePostModal":"DeletePostModal_deletePostModal__35a0a","title":"DeletePostModal_title__nGQTD","buttonsContainer":"DeletePostModal_buttonsContainer__rRp-r"};